module.exports = __webpack_public_path__ + "img/vendor-dex-icon.f366a79d.svg";